import { createFileRoute, Outlet, redirect } from '@tanstack/react-router';

export const Route = createFileRoute('/_auth')({
  beforeLoad: ({ context, location }) => {
    if (!context.auth.isSignedIn) {
      throw redirect({
        to: '/login',
        search: {
          // `location.search` is a parsed object in TanStack Router (it used to
          // serialize as "[object Object]"); `href` carries path + query + hash.
          // The login page sends the user back here once they are signed in.
          redirect: location.href,
        },
      });
    }
  },
  component: AuthLayout,
});

function AuthLayout() {
  return <Outlet />;
}
